/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

export enum USER_ROLES {
  subscriptionUser = 'User',
}

export enum USER_STATUSES {
  pending = 'pending',
  active = 'active',
  inactive = 'inactive',
  deleted = 'deleted',
}

export const USER_LOGOUT_ACTION = 'USER_LOGOUT_ACTION'
